import React from "react";
import ReactiveComponent from "@usereactify/search-internals/lib/components/basic/ReactiveComponent";

export type CustomComponentProps = React.ComponentProps<
  typeof ReactiveComponent
>;

export const CustomComponent: React.FC<CustomComponentProps> = (props) => {
  return <ReactiveComponent {...props} />;
};
